import script from "./GuideStep2.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideStep2.vue?vue&type=script&setup=true&lang=js"

import "./GuideStep2.vue?vue&type=style&index=0&id=2ffa4646&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ffa4646"]])

export default __exports__